import styles from './styles.module.scss';
import { FC } from 'react';

export const OverlayLoader: FC = () => (
  <div className={styles.overlay}>
    <div className={styles.rings}>
      <span className={`${styles.ring} ${styles.ringOuter}`} />
      <span className={`${styles.ring} ${styles.ringMiddle}`} />
      <span className={`${styles.ring} ${styles.ringInner}`} />
    </div>
  </div>
);
